"use strict";
// from https://github.com/LedgerHQ/xpub-scan/blob/master/src/actions/deriveAddresses.ts
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fallbackValidateAddress = void 0;
var bjs = __importStar(require("bitcoinjs-lib"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var address_1 = require("bitcoinjs-lib/src/address");
var bs58check_1 = __importDefault(require("bs58check"));
var types_1 = require("../types");
var bs58_1 = __importDefault(require("bs58"));
var bech32_1 = __importDefault(require("bech32"));
var bip32_1 = __importDefault(require("./bip32"));
function fallbackValidateAddress(address) {
    try {
        bjs.address.fromBase58Check(address);
    }
    catch (_a) {
        // Not a valid Base58 address
        try {
            bjs.address.fromBech32(address);
        }
        catch (_b) {
            // Not a valid Bech32 address either
            return false;
        }
    }
    return true;
}
exports.fallbackValidateAddress = fallbackValidateAddress;
var Base = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Base(_a) {
        var network = _a.network;
        this.network = network;
        this.network.dustThreshold = 3000;
        this.network.dustPolicy = "PER_KBYTE";
        this.network.usesTimestampedTransaction = false;
    }
    Base.prototype.getPubkeyAt = function (xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var keyRoot, rootLevel, buffer, depth, i, chainCode, publicKey, keyAccount, accountLevelP, keyIndex, indexLevelP;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        keyRoot = "".concat(this.network.name, "-").concat(xpub);
                        rootLevel = Base.bip32Cache[keyRoot];
                        if (!rootLevel) {
                            buffer = bs58_1["default"].decode(xpub);
                            depth = buffer[4];
                            i = buffer.readUInt32BE(9);
                            chainCode = buffer.slice(13, 45);
                            publicKey = buffer.slice(45, 78);
                            Base.bip32Cache[keyRoot] = rootLevel = new bip32_1["default"](publicKey, chainCode, this.network, depth, i);
                        }
                        keyAccount = "".concat(keyRoot, "-").concat(account);
                        accountLevelP = Base.bip32Cache[keyAccount];
                        if (!accountLevelP) {
                            Base.bip32Cache[keyAccount] = accountLevelP = rootLevel.derive(account);
                        }
                        keyIndex = "".concat(keyAccount, "-").concat(index);
                        indexLevelP = Base.bip32Cache[keyIndex];
                        if (!indexLevelP) {
                            Base.bip32Cache[keyIndex] = indexLevelP = accountLevelP.then(function (a) {
                                return a.derive(index);
                            });
                        }
                        return [4 /*yield*/, indexLevelP];
                    case 1: 
                    // We can finally return the publicKey. in most case, indexLevelP will be "resolved"
                    return [2 /*return*/, (_a.sent()).publicKey];
                }
            });
        });
    };
    // derive legacy address at account and index positions
    Base.prototype.getLegacyAddress = function (xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var publicKeyBuffer, publicKeyHash160;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPubkeyAt(xpub, account, index)];
                    case 1:
                        publicKeyBuffer = _a.sent();
                        publicKeyHash160 = bjs.crypto.hash160(publicKeyBuffer);
                        return [2 /*return*/, bjs.address.toBase58Check(publicKeyHash160, this.network.pubKeyHash)];
                }
            });
        });
    };
    // derive native SegWit at account and index positions
    Base.prototype.getNativeSegWitAddress = function (xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var publicKeyBuffer, publicKeyHash160, words;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPubkeyAt(xpub, account, index)];
                    case 1:
                        publicKeyBuffer = _a.sent();
                        publicKeyHash160 = bjs.crypto.hash160(publicKeyBuffer);
                        words = bech32_1["default"].toWords(publicKeyHash160);
                        words.unshift(0x00);
                        return [2 /*return*/, bech32_1["default"].encode(this.network.bech32, words)];
                }
            });
        });
    };
    // derive SegWit at account and index positions
    Base.prototype.getSegWitAddress = function (xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var publicKeyBuffer, redeemOutput, publicKeyHash160, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPubkeyAt(xpub, account, index)];
                    case 1:
                        publicKeyBuffer = _a.sent();
                        redeemOutput = bjs.script.compile([
                            0,
                            bjs.crypto.hash160(publicKeyBuffer),
                        ]);
                        publicKeyHash160 = bjs.crypto.hash160(redeemOutput);
                        payload = Buffer.allocUnsafe(21);
                        payload.writeUInt8(this.network.scriptHash, 0);
                        publicKeyHash160.copy(payload, 1);
                        return [2 /*return*/, bs58check_1["default"].encode(payload)];
                }
            });
        });
    };
    // get address given an address type
    Base.prototype.getAddress = function (derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                if (Base.addressCache["".concat(this.network.name, "-").concat(derivationMode, "-").concat(xpub, "-").concat(account, "-").concat(index)]) {
                    return [2 /*return*/, Base.addressCache["".concat(this.network.name, "-").concat(derivationMode, "-").concat(xpub, "-").concat(account, "-").concat(index)]];
                }
                res = this.customGetAddress(derivationMode, xpub, account, index);
                Base.addressCache["".concat(this.network.name, "-").concat(derivationMode, "-").concat(xpub, "-").concat(account, "-").concat(index)] = res;
                return [2 /*return*/, res];
            });
        });
    };
    Base.prototype.customGetAddress = function (derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = derivationMode;
                        switch (_a) {
                            case types_1.DerivationModes.LEGACY: return [3 /*break*/, 1];
                            case types_1.DerivationModes.SEGWIT: return [3 /*break*/, 3];
                            case types_1.DerivationModes.NATIVE_SEGWIT: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, this.getLegacyAddress(xpub, account, index)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3: return [4 /*yield*/, this.getSegWitAddress(xpub, account, index)];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5: return [4 /*yield*/, this.getNativeSegWitAddress(xpub, account, index)];
                    case 6: return [2 /*return*/, _b.sent()];
                    case 7: throw new Error("Invalid derivation Mode: ".concat(derivationMode));
                }
            });
        });
    };
    // infer address type from its syntax
    Base.prototype.getDerivationMode = function (address) {
        if (address.match("^(bc1|tb1).*")) {
            return types_1.DerivationModes.NATIVE_SEGWIT;
        }
        if (address.match("^(3|2|M).*")) {
            return types_1.DerivationModes.SEGWIT;
        }
        if (address.match("^(1|n|m|L).*")) {
            return types_1.DerivationModes.LEGACY;
        }
        throw new Error("INVALID ADDRESS: ".concat(address).concat(" is not a valid address"));
    };
    Base.prototype.toOutputScript = function (address) {
        return (0, address_1.toOutputScript)(address, this.network);
    };
    Base.prototype.validateAddress = function (address) {
        // bs58 address
        var res = bs58check_1["default"].decodeUnsafe(address);
        if (!res)
            return false;
        return (res.length > 3 &&
            (res[0] === this.network.pubKeyHash || res[0] === this.network.scriptHash));
    };
    // eslint-disable-next-line
    Base.prototype.isTaprootAddress = function (address) {
        return false;
    };
    Base.bip32Cache = {}; // xpub + account + index to publicKey
    Base.addressCache = {}; // derivationMode + xpub + account + index to address
    return Base;
}());
exports["default"] = Base;
//# sourceMappingURL=base.js.map